export default "__VITE_ASSET__BlSnshYo__"